export const fonts = {
  // eslint-disable-next-line quotes
  sans: "'Poppins',sans-serif",
} as const

export const fontSize = {
  REM_1: '1rem',
  REM_075: '0.75rem',
  REM_085: '0.85rem',
  REM_725: '0.725rem',
} as const

export const color = {
  white: '#ffffff',
  black: '#000000',
  boxShadowBlack: '#00000014',
  cyan: '#101111',
  cerulean: '#00a2ed',
  greenCyan: '#30e693',
  tealishBlue: '#324fa5',
  paleYellow: '#f6f6ee',
  cyanBlu: '#171f26',
  mercury: '#e6e6e6',
  waterMelon: '#ee4b68',
  lavaRed: '#ed1c24',
  vistaWhite: '#FAFAFA',
  carbonGrey: '#5D5D5D',
  blackCow: '#484848',
  algaeGreen: '#70E39A',
  charcoal: '#333333',
  celestialBlue: '#479FE7',
  darkJungle: '#222222',
  smokeyGrey: '#707070',
  niceBlue: '#1871b9',
  gray50: '#808080',
  gray30: '#B3B3B3',
  gunsmoke: '#868686',
  charCoal: '#182026',
  officialBlue: '#499fda',
  oktaBorder: '#d8d8d8',
  gray10: '#E5E5E5',
  boneWhite: '#f7f7f8',
  graniteGray: '#585858',
  coolGray: '#e6ebef',
  warningYellow: '#E2A507',
  uiAlertRed: '#bd0000',
  doveGrey: '#676767',
  whiteSmoke: '#F6F6F6',
  snowDrift: '#F9F9F9',
  whiteLitac: '#F5F7F8',
  midGrey: '#585E65',
  paleSky: '#6C7478',
  platinum: '#E2E2E2',
  porcelain: 'f2f2f2',
  red: '#ff0000',
  desertStorm: '#F8F8F8',
  lavenderPinocchio: '#E0E0E0',
  balticSea: '#24282E',
  bilobaFlower: '#B5A7DD',
  lightTan: '#FFEDB1',
  hampton: '#D1DDA7',
  morningGlory: '#A7DBDD',
  sunsetOrange: '#FF5757',
  charcoalGrey: '#414141',
  lightRed: '#ff4848',
  twilightBlue: '#F5FBFF',
  burningSand: '#e38f70',
  mediumSlateBlue: '#7470e3',
  chinook: '#9FE9C3',
  teaGreen: '#BFF2D2',
  seaMist: '#BDE0CA',
  lightTeal: '#6AD989',
  forestGreen: '#389468',
} as const
